module.exports = __webpack_public_path__ + "static/media/9-iveco.78f3d6c8.jpg";